import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography , Menu , MenuItem , TextField , Box, ButtonGroup, InputAdornment, Pagination } from "@mui/material";
import {ListAlt ,SignalCellularAlt , AirportShuttle, Search, FilterList} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";
import io from "socket.io-client";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from 'moment-timezone';
//Services
import TriplistApi from "Services/Triplist";
import ServiceApi from "Services/Service";
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Moredetails";
import { CUSTOM_CONSTANTS } from "Constants/index";


// Helper: get current year's date range in formatted string
const getYearRange = () => {
  const start = moment().startOf('year').format("MM/DD/YYYY HH:mm:ss");
  const end = moment().endOf('year').format("MM/DD/YYYY HH:mm:ss");
  return { start, end };
};

function convertToISO(inputDate) {
  if (!inputDate) {
    return "--"; // Handle null or undefined input
  }

  // Parse the input date string
  const date = new Date(inputDate);

  if (isNaN(date.getTime())) {
    return "--"; // Handle invalid date formats
  }

  // Convert to ISO string and replace "Z" with "+00:00" for UTC offset
  const isoString = date.toISOString().replace("Z", "+00:00");
  return isoString;
}

const yearRange = getYearRange();

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [searchText, setSearchText] = useState("");
  const timezone = useSelector((state) => state.timezone.timezone);
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);
  const Tripstatus = ["CANCELLED", "COMPLETED", "SCHEDULED"];
  const Paymentmethod = ["CASH", "CARD", "CORPORATE"];
  const [servicesData, setServicesData] = useState([]);
  const [filtervalues , setFiltervalues] = useState({
    fromdate: convertToISO(yearRange.start),
    todate: convertToISO(yearRange.end),
  });
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const [requestId, setrequestId] = useState("");
  const [metrics,setmetrics] = useState({});

  // Fetch services list for filter dropdown
  useEffect(() => {
    ServiceApi.getServices({ limit: "unlimited" })
      .then((res) => {
        if (res?.data?.data?.data) {
          setServicesData(res.data.data.data);
        }
      })
      .catch((err) => console.log("Failed to fetch services", err));
  }, []);

  // Get trip list api

  const gettriplists = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data.triplists);
        setmetrics({
          totalRidesCount: res?.data?.data.totalRidesCount,
          cancelledRides: res?.data?.data.cancelledRides,
          totalRevenue: res?.data?.data.totalRevenue,
        });

      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    TriplistApi.getoverallstatement({ page, limit: pageSize , filtervalues })
      .then(onSuccess, onFailure);
  }, [page, pageSize, filtervalues]);

  useEffect(() => {
    gettriplists();
  }, [gettriplists]);


  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  function formatDate(inputDate) {
    if (!inputDate) {
      return "--"; // Return '--' if inputDate is null or undefined
    }
    
  return moment(inputDate).tz(timezone).format("YYYY-MM-DD hh:mm A");

  }

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const handleview = (event, rowData) => {
    setrequestId(rowData?._id);
    setmoredetailsModal(true);
  };
 
  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
    gettriplists();
  };

  const filteredRow = (row || []).filter((data) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    const passengerName = `${data?.userdetails?.firstName || ""} ${data?.userdetails?.lastName || ""}`.toLowerCase();
    const driverName = data?.driverdetails ? `${data.driverdetails.firstName || ""} ${data.driverdetails.lastName || ""}`.toLowerCase() : "not exists";
    return (
      data?.bookingId?.toLowerCase().includes(searchLower) ||
      data?.pickupAddress?.toLowerCase().includes(searchLower) ||
      data?.dropAddress?.toLowerCase().includes(searchLower) ||
      data?.tripStatus?.toLowerCase().includes(searchLower) ||
      data?.paymentMode?.toLowerCase().includes(searchLower) ||
      passengerName.includes(searchLower) ||
      driverName.includes(searchLower)
    );
  });

  const dataRows = _.map(filteredRow || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    pickuplocation: data?.pickupAddress,
    stop1address:data?.stop1_address,
    stop2address:data?.stop2_address,
    bookingId: data?.bookingId,
    droplocation: data?.dropAddress,
    requestedAt: formatDate(data?.requestedAt),
    status:data?.tripStatus,
    Paymentmode:data?.paymentMode,
    Total:data?.estimatedFare.toFixed(2),
    commission:data?.earnedCommission,
    driverearned:data?.driverEarnings && data?.tripStatus=="COMPLETED" ? (data?.driverEarnings?.earnings ?? 0).toFixed(2):0,
    statusbackground:data?.tripStatus ? 
    data?.tripStatus == "COMPLETED" ? "#00c292" : 
    data?.tripStatus == "CANCELLED" ? "#f8312fd6" : "#2d7ea8"
    : "#2d7ea8",
    row: data,
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 1,
      minWidth: 60, 
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "bookingId",
      headerName: "Booking ID",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.bookingId}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "pickuplocation",
      headerName: "Picked up",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.pickuplocation}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop1address",
      headerName: "Stop 1",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.stop1address || "--"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "stop2address",
      headerName: "Stop 2",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.stop2address || "--"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "droplocation",
      headerName: "Drop location",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.droplocation}</Typography>
            </div>
          </>
        );
      },
    },
    {
    field: "actions",
    headerName: "Request Details",
    minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const rowData = params?.row?.row;
      return (
        <>
    <div className={classes.iconsWrapper}>
    <Button
      id="basic-button"
      aria-controls={openaction ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={openaction ? 'true' : undefined}
      onClick={(e) => handleview(e, rowData)}
    >
      View
    </Button>
        </div>
        </>
      );
    },
    }, 
    {
      field: "requestedAt",
      headerName: "Dated on",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.requestedAt}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography className={classes.status} 
              sx={{ background: params?.row?.statusbackground }}
              variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "Paymentmode",
      headerName: "Payment Mode",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.Paymentmode}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "Total",
      headerName: "Total",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.Total}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "commission",
      headerName: "Commission",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.commission}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "driverearned",
      headerName: "Earned by driver",
      flex: 2,
      minWidth: 150, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.driverearned}</Typography>
            </div>
          </>
        );
      },
    },
  ];

  // handle dates

const handlefromdate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("fromdate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("fromdate", formattedDate);
  }
};

const handletodate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("todate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("todate", formattedDate);
  }
};

  // filter form 

const handlefiltertriplist = (formValues) => {
   
  formValues.fromdate = convertToISO(formValues.fromdate);
  formValues.todate = convertToISO(formValues.todate);
  setFiltervalues(formValues);
  };

  const formik = useFormik({
    initialValues: {
      tripStatus: "",
      paymentMode: "",
      serviceTypeId: "",
      fromdate: yearRange.start,
      todate: yearRange.end,
    },
    validationSchema: yup.object({
      fromdate: yup.string().required("Status is required").nullable(),
      todate: yup.string().required("Service is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlefiltertriplist(values); // Ensure this processes `values` correctly
    },
  });

  const CustomPagination = () => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 3, borderTop: '1px solid #e0e0e0', width: '100%', boxSizing: 'border-box' }}>
        <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '14px', fontWeight: 500 }}>
          Showing {((page - 1) * pageSize) + 1} to {Math.min(page * pageSize, totalPages)} of {totalPages} results
        </Typography>
        <Pagination
          count={Math.ceil(totalPages / pageSize) || 1}
          page={page}
          onChange={(event, value) => {
             setPage(value);
             handlePageChange(value - 1); 
          }}
          shape="rounded"
          sx={{
            "& .MuiPaginationItem-root": {
               border: 'none',
               fontWeight: 500,
            },
            "& .Mui-selected": {
               backgroundColor: "#2a2d34 !important",
               color: "#fff",
            }
          }}
        />
      </Box>
    );
  };
  
  return (  
    <>

<div className={classes.pages}>
<Grid container className={classes.root}>

<Grid item xs={12} className={classes.headerSection}>
  <Typography variant="h4" className={classes.pageTitle}>Yearly Ride Statements</Typography>
  <div className={classes.searchContainer}>
    <TextField
      placeholder="Search"
      size="small"
      value={searchText}
      onChange={(e) => {
        setSearchText(e.target.value);
        setPage(1);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search color="action" />
          </InputAdornment>
        ),
      }}
      className={classes.searchInput}
    />
  </div>
</Grid>

<Grid container className={classes.metricboxes} spacing={3}>

<Grid item xs={12} md={4}>
  <Box className={classes.metricboxCard}>
    <div className={classes.metricboxContent}>
      <Typography className={classes.metricTitle}>Total No. Of Rides</Typography>
      <Typography className={classes.metricValue}>{metrics?.totalRidesCount || 0}</Typography>
    </div>
    <img src="/assets/images/Dashboardiconnew/totalrides.png" alt="Total Rides" className={classes.metricIcon} />
  </Box>
</Grid>
<Grid item xs={12} md={4}>
  <Box className={classes.metricboxCard}>
    <div className={classes.metricboxContent}>
      <Typography className={classes.metricTitle}>Revenue</Typography>
      <Typography className={classes.metricValue}>{CUSTOM_CONSTANTS.BASE_CURRENCY} {metrics?.totalRevenue || 0}</Typography>
    </div>
    <img src="/assets/images/Dashboardiconnew/revenuetotal.png" alt="Revenue" className={classes.metricIcon} />
  </Box>
</Grid>
<Grid item xs={12} md={4}>
  <Box className={classes.metricboxCard}>
    <div className={classes.metricboxContent}>
      <Typography className={classes.metricTitle}>Cancelled Rides</Typography>
      <Typography className={classes.metricValue}>{metrics?.cancelledRides || 0}</Typography>
    </div>
    <img src="/assets/images/Dashboardiconnew/totalcancelride.png" alt="Cancelled" className={classes.metricIcon} />
  </Box>
</Grid>

</Grid>

<Grid container className={classes.utilities} alignItems="center">
  <Grid item xs={12} md={7} lg={7} className={classes.filtersContainer}>
    <TextField
      name="tripStatus"
      id="tripStatus"
      select
      value={formik?.values?.tripStatus || ""}
      onChange={formik?.handleChange}
      variant="outlined"
      size="small"
      SelectProps={{ displayEmpty: true }}
      className={classes.roundedFilter}
    >
      <MenuItem key="All status" value="">
        All Status
      </MenuItem>
      {Tripstatus.map((status) => (
        <MenuItem key={status} value={status}>
          {status}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      name="serviceTypeId"
      id="serviceTypeId"
      select
      value={formik?.values?.serviceTypeId || ""}
      onChange={formik?.handleChange}
      variant="outlined"
      size="small"
      SelectProps={{ displayEmpty: true }}
      className={classes.roundedFilter}
    >
      <MenuItem key="All services" value="">
        All Services
      </MenuItem>
      {servicesData.map((service) => (
        <MenuItem key={service._id} value={service._id}>
          {service.serviceName}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      name="paymentMode"
      id="paymentMode"
      select
      value={formik?.values?.paymentMode || ""}
      onChange={formik?.handleChange}
      variant="outlined"
      size="small"
      SelectProps={{ displayEmpty: true }}
      className={classes.roundedFilter}
    >
      <MenuItem key="All payment" value="">
        All Payments
      </MenuItem>
      {Paymentmethod.map((booking) => (
        <MenuItem key={booking} value={booking}>
          {booking}
        </MenuItem>
      ))}
    </TextField>

    <div className={classes.datePickerStyle}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={formik?.values?.fromdate || null}
          onChange={(newValue) => {
            handlefromdate(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="From Date" className={classes.roundedFilter} />
          )}
        />
      </LocalizationProvider>
    </div>

    <div className={classes.datePickerStyle}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={formik?.values?.todate || null}
          onChange={(newValue) => {
            handletodate(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="To Date" className={classes.roundedFilter} />
          )}
        />
      </LocalizationProvider>
    </div>
  </Grid>

  <Grid item xs={12} md={5} lg={5} className={classes.actionsContainer}>
    <ButtonGroup className={classes.buttonGroup} variant="outlined">
      <Button>Copy</Button>
      <Button>Excel</Button>
      <Button>CSV</Button>
      <Button>PDF</Button>
    </ButtonGroup>
    <Button 
      variant="contained" 
      className={classes.moreFiltersBtn} 
      startIcon={<FilterList />}
      onClick={formik?.handleSubmit}
    >
      More Filters
    </Button>
  </Grid>
</Grid>

<Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
       className={classes.tripgridtable}
        getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        components={{
          Footer: CustomPagination,
        }}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={100}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
</Grid>

</Grid>
<Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
></Passengerhistorydetails>
</div>

    </>
  );
};

export default Passenger;
